(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-pro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '[data-bc39-section]';
  const GLOBAL_KEY = '__bundleWaveFourColumnV39';
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const rangeProgress = (value, start, end) => {
    if (end <= start) return value >= end ? 1 : 0;
    return clamp((value - start) / (end - start), 0, 1);
  };

  const smoothstep = (value) => {
    const x = clamp(value, 0, 1);
    return x * x * (3 - 2 * x);
  };

  const smootherstep = (value) => {
    const x = clamp(value, 0, 1);
    return x * x * x * (x * (x * 6 - 15) + 10);
  };

  const easeInOutSine = (value) => {
    const x = clamp(value, 0, 1);
    return 0.5 - 0.5 * Math.cos(Math.PI * x);
  };

  const softStartLinear = (value, easePortion) => {
    const x = clamp(value, 0, 1);
    const e = clamp(easePortion, 0, 0.45);
    if (e <= 0.0001) return x;

    const raw =
      x < e
        ? (x * x) / (2 * e)
        : x - e / 2;

    return clamp(raw / (1 - e / 2), 0, 1);
  };

  const readNumber = (root, key, fallback) => {
    const value = Number.parseFloat(root.dataset[key]);
    return Number.isFinite(value) ? value : fallback;
  };

  /*
    一阶追随仅用于顶部渐隐透明度，不再控制卡片移动。
  */
  const follow = (current, target, milliseconds, deltaSeconds) => {
    const tau = Math.max(milliseconds, 1) / 1000;
    const alpha = 1 - Math.exp(-Math.min(deltaSeconds, 0.05) / tau);
    return current + (target - current) * alpha;
  };

  /*
    无回弹临界阻尼：
    - 保存当前位置与速度，所以滚轮停止后会有很短的惯性收尾；
    - 反向滚动时先自然减速，再平滑换向；
    - Unity SmoothDamp 同类算法会防止越过目标，不产生弹簧回弹；
    - deltaTime 上限避免标签页切换或卡顿后突然跳动。
  */
  const smoothDamp = (
    current,
    target,
    currentVelocity,
    smoothTimeSeconds,
    maxSpeed,
    deltaSeconds
  ) => {
    const smoothTime = Math.max(0.0001, smoothTimeSeconds);
    const dt = Math.min(Math.max(deltaSeconds, 0), 0.05);
    const omega = 2 / smoothTime;
    const x = omega * dt;
    const decay = 1 / (1 + x + 0.48 * x * x + 0.235 * x * x * x);

    let change = current - target;
    const originalTarget = target;
    const maximumChange = Math.max(maxSpeed, 1) * smoothTime;
    change = clamp(change, -maximumChange, maximumChange);
    target = current - change;

    const temp = (currentVelocity + omega * change) * dt;
    let nextVelocity =
      (currentVelocity - omega * temp) * decay;
    let output =
      target + (change + temp) * decay;

    /*
      禁止越过目标后反弹。
    */
    if (
      ((originalTarget - current) > 0)
      === (output > originalTarget)
    ) {
      output = originalTarget;
      nextVelocity = 0;
    }

    return {
      value: output,
      velocity: nextVelocity
    };
  };

  const existing = window[GLOBAL_KEY];
  if (existing) {
    existing.scan(document);
    return;
  }

  const controller = {
    roots: new Map(),
    rafId: 0,
    lastTime: performance.now(),

    add(root) {
      if (this.roots.has(root)) return;

      const state = {
        commonOffset: 0,
        commonVelocity: 0,
        spreadOffset: 0,
        spreadVelocity: 0,
        previousCommonTarget: 0,
        previousSpreadTarget: 0,
        oddOffset: 0,
        evenOffset: 0,
        fadeOpacity: 0
      };

      this.roots.set(root, state);
      this.initMobileCarousel(root);
      this.updateRoot(root, state, 1 / 60, true);
    },

    initMobileCarousel(root) {
      const viewport = root.querySelector('[data-bc39-mobile-carousel]');
      const track = root.querySelector('[data-bc39-mobile-track]');
      if (!viewport || !track || track.dataset.bc39LoopReady === 'true') return;

      const realPages = Array.from(
        track.querySelectorAll(':scope > [data-bc39-mobile-page]')
      );

      track.dataset.bc39LoopReady = 'true';

      if (realPages.length <= 1) {
        track.style.scrollSnapType = 'none';
        return;
      }

      const firstClone = realPages[0].cloneNode(true);
      const lastClone = realPages[realPages.length - 1].cloneNode(true);

      firstClone.dataset.bc39Clone = 'first';
      lastClone.dataset.bc39Clone = 'last';
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');

      firstClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.tabIndex = -1;
      });
      lastClone.querySelectorAll('a, button, input, select, textarea').forEach((element) => {
        element.tabIndex = -1;
      });

      track.prepend(lastClone);
      track.append(firstClone);

      let realIndex = 0;
      let scrollTimer = 0;

      const pageWidth = () => Math.max(track.clientWidth, 1);

      const jumpTo = (pageIndex) => {
        track.style.scrollSnapType = 'none';
        track.scrollLeft = pageIndex * pageWidth();
        requestAnimationFrame(() => {
          track.style.scrollSnapType = 'inline mandatory';
        });
      };

      const normalize = () => {
        const width = pageWidth();
        const pageIndex = Math.round(track.scrollLeft / width);

        if (pageIndex <= 0) {
          realIndex = realPages.length - 1;
          jumpTo(realPages.length);
          return;
        }

        if (pageIndex >= realPages.length + 1) {
          realIndex = 0;
          jumpTo(1);
          return;
        }

        realIndex = pageIndex - 1;
      };

      const queueNormalize = () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(normalize, 90);
      };

      track.addEventListener('scroll', queueNormalize, { passive: true });

      if ('onscrollend' in track) {
        track.addEventListener('scrollend', normalize, { passive: true });
      }

      const resizeObserver = new ResizeObserver(() => {
        jumpTo(realIndex + 1);
      });
      resizeObserver.observe(track);

      requestAnimationFrame(() => jumpTo(1));
    },

    scan(scope = document) {
      if (scope.matches?.(ROOT_SELECTOR)) this.add(scope);
      scope.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => this.add(root));
    },

    clean() {
      this.roots.forEach((_state, root) => {
        if (!root.isConnected) this.roots.delete(root);
      });
    },

    getLayoutMetrics(root) {
      const grid = root.querySelector('[data-bc39-grid]');
      if (!grid) return null;

      /* 取未受 transform 影响的布局尺寸，避免运动反过来改变触发进度。 */
      const referenceColumn =
        root.querySelector('[data-bc39-column-index="1"]')
        || root.querySelector('[data-bc39-column-index="3"]')
        || root.querySelector('[data-bc39-column-index="0"]');

      if (!referenceColumn) return null;

      const cards = Array.from(referenceColumn.querySelectorAll('[data-bc39-card]'));
      if (!cards.length) return null;

      const lastRowCard =
        root.dataset.bc39Layout === 'double'
          ? cards[cards.length - 1]
          : cards[0];

      const cardHeight = Math.max(lastRowCard.offsetHeight, 1);
      const rootRect = root.getBoundingClientRect();
      const gridRect = grid.getBoundingClientRect();
      const gridTopLocal = gridRect.top - rootRect.top;
      const lastRowBottomLocal =
        gridTopLocal
        + lastRowCard.offsetTop
        + cardHeight;

      return {
        cardHeight,
        lastRowBottomLocal
      };
    },

    /*
      自动识别当前真正覆盖页面内容的吸顶 Header。
      参考站的渐隐是从可见内容区域的上边缘开始，而不是永远从 viewport y=0 开始。
      这能兼容 Horizon 的 sticky header，也避免写死某个主题高度。
    */
    getTopOcclusion(root) {
      const viewportWidth = Math.max(
        window.innerWidth || document.documentElement.clientWidth || 1,
        1
      );
      const sampleXs = [
        viewportWidth * 0.18,
        viewportWidth * 0.50,
        viewportWidth * 0.82
      ];

      let occlusionBottom = 0;
      const inspected = new Set();

      sampleXs.forEach((x) => {
        const stack = document.elementsFromPoint(
          clamp(x, 1, viewportWidth - 2),
          1
        );

        stack.forEach((element) => {
          let node = element;

          while (
            node
            && node !== document.documentElement
            && node !== document.body
          ) {
            if (inspected.has(node)) {
              node = node.parentElement;
              continue;
            }
            inspected.add(node);

            if (!root.contains(node)) {
              const style = getComputedStyle(node);
              const position = style.position;
              const rect = node.getBoundingClientRect();
              const wideEnough = rect.width >= viewportWidth * 0.45;
              const sensibleHeight = rect.height >= 28 && rect.height <= 220;
              const touchesTop = rect.top <= 2 && rect.bottom > 2;
              const visible =
                style.display !== 'none'
                && style.visibility !== 'hidden'
                && Number.parseFloat(style.opacity || '1') > 0.02;

              if (
                visible
                && wideEnough
                && sensibleHeight
                && touchesTop
                && (position === 'fixed' || position === 'sticky')
              ) {
                occlusionBottom = Math.max(
                  occlusionBottom,
                  rect.bottom
                );
              }
            }

            node = node.parentElement;
          }
        });
      });

      return clamp(occlusionBottom, 0, 220);
    },

    updateRoot(root, state, dt, immediate = false) {
      const metrics = this.getLayoutMetrics(root);
      const cover = root.querySelector('[data-bc39-cover]');
      const backdrop = root.querySelector('.bc39-backdrop');
      if (!metrics || !cover) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        state.commonOffset = 0;
        state.commonVelocity = 0;
        state.spreadOffset = 0;
        state.spreadVelocity = 0;
        state.previousCommonTarget = 0;
        state.previousSpreadTarget = 0;
        state.oddOffset = 0;
        state.evenOffset = 0;
        state.fadeOpacity = 0;

        root.querySelectorAll('[data-bc39-column]').forEach((column) => {
          column.style.setProperty('--bc39-column-y', '0px');
        });
        cover.style.setProperty('--bc39-fade-opacity', '0');
        return;
      }

      const rootRect = root.getBoundingClientRect();
      const topOcclusion = this.getTopOcclusion(root);
      const viewportHeight = Math.max(
        window.innerHeight
          || document.documentElement.clientHeight
          || 1,
        1
      );
      const usableViewportHeight = Math.max(
        viewportHeight - topOcclusion,
        1
      );
      const sectionHeight = Math.max(root.offsetHeight, 1);
      const localSectionScroll = clamp(
        topOcclusion - rootRect.top,
        0,
        sectionHeight + metrics.cardHeight * 2
      );

      const heading =
        root.querySelector('.bc39-heading')
        || root.querySelector('.bc39-header')
        || root;
      const headingRect = heading.getBoundingClientRect();
      const headingLocalTop = clamp(
        headingRect.top - rootRect.top,
        0,
        sectionHeight
      );
      const headingHeight = Math.max(headingRect.height, 1);

      /*
        起点：标题指定位置到达固定 Header 底部。
        默认 50%，即标题垂直中心触发。
      */
      const triggerHeadingPercent = clamp(
        readNumber(
          root,
          'bc39MotionTriggerHeadingPercent',
          25
        ) / 100,
        0,
        1
      );
      const motionStartScroll =
        headingLocalTop
        + headingHeight * triggerHeadingPercent;

      /*
        终点：黑色视觉背景底边到达可视内容区顶部指定位置。
        默认 22%。

        数值越小，终点越靠近顶部，道路越长；
        数值越大，终点越靠下，道路越短。
      */
      const endViewportPercent = clamp(
        readNumber(
          root,
          'bc39MotionEndViewportPercent',
          22
        ) / 100,
        0.03,
        0.60
      );

      const backgroundBottomLocal = backdrop
        ? Math.max(
            backdrop.offsetTop + backdrop.offsetHeight,
            1
          )
        : sectionHeight;

      const motionEndLine =
        usableViewportHeight * endViewportPercent;
      const motionEndScroll =
        backgroundBottomLocal - motionEndLine;

      /*
        正常情况下道路由真实几何位置决定。
        极端小视口下保留最低道路，避免进度瞬间跳满。
      */
      const roadDistance = Math.max(
        motionEndScroll - motionStartScroll,
        metrics.cardHeight * 0.35
      );
      const roadTravel = clamp(
        localSectionScroll - motionStartScroll,
        0,
        roadDistance
      );
      const roadProgress = clamp(
        roadTravel / roadDistance,
        0,
        1
      );

      /*
        只柔化道路最开始很短的一段。
        默认 3%，之后保持接近线性增长。
      */
      const startEasePercent = clamp(
        readNumber(root, 'bc39StartEasePercent', 3) / 100,
        0,
        0.25
      );
      const commonProgress = softStartLinear(
        roadProgress,
        startEasePercent
      );

      const spreadAdvance = clamp(
        readNumber(root, 'bc39SpreadAdvance', 0) / 100,
        0,
        0.30
      );

      /*
        高低差只使用同一条道路的前一部分。
        默认在道路 75% 时达到最大值，之后列间距离保持稳定；
        四列共同上移仍继续运行到背景离场终点。
      */
      const spreadCompleteProgress = clamp(
        readNumber(
          root,
          'bc39SpreadCompleteProgress',
          75
        ) / 100,
        0.35,
        1
      );
      const spreadRoadProgress = clamp(
        (roadProgress + spreadAdvance)
          / spreadCompleteProgress,
        0,
        1
      );
      const spreadProgress = softStartLinear(
        spreadRoadProgress,
        startEasePercent
      );

      const isSingle =
        root.dataset.bc39Layout === 'single';

      /*
        双行默认幅度：

        第2、4列共同额外上移：
        卡片高度 48%。

        第1、3列在共同位移上继续增加：
        卡片高度 20%。

        409px 卡片约为：
        偶数列 196px；
        最终高低差 82px；
        奇数列总额外上移 278px。
      */
      const commonMaxPercent = clamp(
        readNumber(
          root,
          isSingle
            ? 'bc39SingleCommonMaxPercent'
            : 'bc39DoubleCommonMaxPercent',
          isSingle ? 34 : 48
        ) / 100,
        0,
        0.90
      );
      const spreadMaxPercent = clamp(
        readNumber(
          root,
          isSingle
            ? 'bc39SingleSpreadMaxPercent'
            : 'bc39DoubleSpreadMaxPercent',
          isSingle ? 14 : 20
        ) / 100,
        0,
        0.70
      );
      const distanceScale = clamp(
        readNumber(root, 'bc39DistanceScale', 100) / 100,
        0.50,
        1.80
      );

      const commonMaxDistance =
        metrics.cardHeight
        * commonMaxPercent
        * distanceScale;
      const spreadMaxDistance =
        metrics.cardHeight
        * spreadMaxPercent
        * distanceScale;

      const commonTarget =
        -commonMaxDistance * commonProgress;
      const spreadTarget =
        -spreadMaxDistance * spreadProgress;

      /*
        惯性只改变到达目标的节奏。
        当 roadProgress 达到 1 后，目标位置封顶。
      */
      const commonSmoothMs = clamp(
        readNumber(root, 'bc39CommonSmoothMs', 330),
        120,
        760
      );
      const spreadSmoothMs = clamp(
        readNumber(root, 'bc39SpreadSmoothMs', 370),
        commonSmoothMs + 20,
        900
      );
      const motionMaxSpeed = clamp(
        readNumber(root, 'bc39MotionMaxSpeed', 2600),
        800,
        5200
      );
      const commonLagCap =
        metrics.cardHeight
        * clamp(
          readNumber(root, 'bc39CommonLagPercent', 7) / 100,
          0.01,
          0.18
        );
      const spreadLagCap =
        metrics.cardHeight
        * clamp(
          readNumber(root, 'bc39SpreadLagPercent', 3) / 100,
          0.01,
          0.14
        );
      const reverseRetention = clamp(
        readNumber(root, 'bc39ReverseRetention', 68) / 100,
        0.30,
        0.92
      );

      if (immediate) {
        state.commonOffset = commonTarget;
        state.commonVelocity = 0;
        state.spreadOffset = spreadTarget;
        state.spreadVelocity = 0;
      } else {
        const commonTargetDelta =
          commonTarget - state.previousCommonTarget;
        const spreadTargetDelta =
          spreadTarget - state.previousSpreadTarget;

        if (
          commonTargetDelta !== 0
          && state.commonVelocity !== 0
          && Math.sign(commonTargetDelta)
            !== Math.sign(state.commonVelocity)
        ) {
          state.commonVelocity *= reverseRetention;
        }

        if (
          spreadTargetDelta !== 0
          && state.spreadVelocity !== 0
          && Math.sign(spreadTargetDelta)
            !== Math.sign(state.spreadVelocity)
        ) {
          state.spreadVelocity *=
            Math.min(reverseRetention + 0.08, 0.94);
        }

        const commonResult = smoothDamp(
          state.commonOffset,
          commonTarget,
          state.commonVelocity,
          commonSmoothMs / 1000,
          motionMaxSpeed,
          dt
        );
        state.commonOffset = commonResult.value;
        state.commonVelocity = commonResult.velocity;

        const spreadResult = smoothDamp(
          state.spreadOffset,
          spreadTarget,
          state.spreadVelocity,
          spreadSmoothMs / 1000,
          motionMaxSpeed * 0.72,
          dt
        );
        state.spreadOffset = spreadResult.value;
        state.spreadVelocity = spreadResult.velocity;

        const commonError =
          state.commonOffset - commonTarget;
        if (Math.abs(commonError) > commonLagCap) {
          state.commonOffset =
            commonTarget
            + Math.sign(commonError) * commonLagCap;
          state.commonVelocity *= 0.86;
        }

        const spreadError =
          state.spreadOffset - spreadTarget;
        if (Math.abs(spreadError) > spreadLagCap) {
          state.spreadOffset =
            spreadTarget
            + Math.sign(spreadError) * spreadLagCap;
          state.spreadVelocity *= 0.82;
        }
      }

      state.previousCommonTarget = commonTarget;
      state.previousSpreadTarget = spreadTarget;
      state.evenOffset = state.commonOffset;
      state.oddOffset =
        state.commonOffset + state.spreadOffset;

      root.querySelectorAll('[data-bc39-column]').forEach((column) => {
        const index = Number.parseInt(
          column.dataset.bc39ColumnIndex || '0',
          10
        );
        const fasterColumn = index === 0 || index === 2;
        const offset =
          fasterColumn
            ? state.oddOffset
            : state.evenOffset;

        column.style.setProperty(
          '--bc39-column-y',
          `${offset.toFixed(3)}px`
        );
      });

      /*
        顶部阴影仍由标题自身位置触发。
      */
      const shadowTriggerHeadingPercent = clamp(
        readNumber(
          root,
          'bc39ShadowTriggerHeadingPercent',
          0
        ) / 100,
        -0.50,
        1
      );
      const shadowStartScroll =
        headingLocalTop
        + headingHeight * shadowTriggerHeadingPercent;
      const shadowSpanPercent = clamp(
        readNumber(root, 'bc39ShadowSpanPercent', 28) / 100,
        0.08,
        0.80
      );
      const shadowDistance = Math.max(
        metrics.cardHeight * shadowSpanPercent,
        1
      );
      const shadowProgress = smootherstep(
        rangeProgress(
          localSectionScroll,
          shadowStartScroll,
          shadowStartScroll + shadowDistance
        )
      );
      const fadeStrength = clamp(
        readNumber(root, 'bc39FadeStrength', 100) / 100,
        0.5,
        1
      );
      const targetFadeOpacity =
        shadowProgress * fadeStrength;
      const shadowFollowMs = clamp(
        readNumber(root, 'bc39ShadowFollowMs', 190),
        70,
        440
      );

      if (immediate) {
        state.fadeOpacity = targetFadeOpacity;
      } else {
        state.fadeOpacity = follow(
          state.fadeOpacity,
          targetFadeOpacity,
          shadowFollowMs,
          dt
        );
      }

      const fadeHeight = Math.max(
        Number.parseFloat(
          getComputedStyle(root).getPropertyValue('--bc39-fade-height')
        ) || 135,
        1
      );
      const fadeLaneOffset = clamp(
        readNumber(root, 'bc39FadeLaneOffset', 0),
        -80,
        160
      );
      const fadeAnchorY = clamp(
        topOcclusion + fadeLaneOffset - rootRect.top,
        0,
        Math.max(sectionHeight - fadeHeight, 0)
      );

      cover.style.setProperty(
        '--bc39-fade-anchor-y',
        `${fadeAnchorY.toFixed(2)}px`
      );
      cover.style.setProperty(
        '--bc39-fade-opacity',
        state.fadeOpacity.toFixed(4)
      );

      if (root.dataset.bc39Debug === 'true') {
        const debugVisible =
          root.querySelector('[data-bc39-debug-visible]');
        const debugTrigger =
          root.querySelector('[data-bc39-debug-trigger]');
        const debugPanel =
          root.querySelector('[data-bc39-debug-panel]');

        debugVisible?.style.setProperty(
          '--bc39-debug-visible-y',
          `${localSectionScroll.toFixed(2)}px`
        );
        debugTrigger?.style.setProperty(
          '--bc39-debug-trigger-y',
          `${motionStartScroll.toFixed(2)}px`
        );

        if (debugPanel) {
          const panelY = clamp(
            localSectionScroll + 12,
            8,
            Math.max(sectionHeight - 140, 8)
          );
          debugPanel.style.setProperty(
            '--bc39-debug-panel-y',
            `${panelY.toFixed(2)}px`
          );
          debugPanel.textContent =
            `标题触发：${(triggerHeadingPercent * 100).toFixed(0)}%`
            + ` ｜ 背景终点：${(endViewportPercent * 100).toFixed(0)}%`
            + ` ｜ 差值封顶：${(spreadCompleteProgress * 100).toFixed(0)}%`
            + ` ｜ 道路：${roadDistance.toFixed(0)}px`
            + ` ｜ 进度：${(roadProgress * 100).toFixed(1)}%`
            + ` ｜ 共同上限：${commonMaxDistance.toFixed(0)}px`
            + ` ｜ 高低差上限：${spreadMaxDistance.toFixed(0)}px`
            + ` ｜ 当前共同：${Math.abs(state.commonOffset).toFixed(1)}px`
            + ` ｜ 当前差值：${Math.abs(state.spreadOffset).toFixed(1)}px`;
        }
      }
    },

    frame(now) {
      const dt = Math.max((now - this.lastTime) / 1000, 1 / 240);
      this.lastTime = now;
      this.clean();

      this.roots.forEach((state, root) => {
        this.updateRoot(root, state, dt, false);
      });

      this.rafId = requestAnimationFrame((time) => this.frame(time));
    },

    start() {
      if (this.rafId) return;

      this.scan(document);
      this.lastTime = performance.now();
      this.rafId = requestAnimationFrame((time) => this.frame(time));

      document.addEventListener('shopify:section:load', (event) => this.scan(event.target));
      document.addEventListener('shopify:section:select', (event) => this.scan(event.target));
      document.addEventListener('shopify:block:select', (event) => this.scan(event.target));
      document.addEventListener('shopify:section:reorder', () => this.scan(document));
      window.addEventListener('pageshow', () => this.scan(document));

      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) this.scan(node);
          });
        });
      });
      this.observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }
  };

  window[GLOBAL_KEY] = controller;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => controller.start(), { once: true });
  } else {
    controller.start();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
